// extracted by mini-css-extract-plugin
module.exports = {"section":"PriceBrief_section_35jZ4"};